export default __webpack_public_path__ + "static/media/payment-payoo.7445a36a.svg";